export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_ENCOURAGE_MSG_READ = "SET_ENCOURAGE_MSG_READ";
